module.exports = __webpack_public_path__ + "static/img/btn.6f26840c.png";